var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".53em",
    height: "1em",
    viewBox: "0 0 19.671 36.728"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18755"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-facebook-f",
    d: "m18.382 20.659 1.02-6.647h-6.378V9.7c0-1.818.891-3.591 3.747-3.591h2.9V.449A35.358 35.358 0 0 0 14.524 0C9.272 0 5.839 3.184 5.839 8.947v5.066H0v6.647h5.839v16.068h7.186V20.659Z",
    fill: "#fec968"
  }))));
};
export default SvgFacebook;